import { useHistory } from 'react-router-dom';
import { useQuery } from '../../../services/Util';
import Modal from '../Partials/Modal';
import Editor from '../Partials/Editor';

export default function ModalModal({ page }) {
	const query = useQuery();
	const history = useHistory();

	const bid = query.get('bid');

	const button = page.buttons.find((b) => {
		return bid === b.id;
	});

	if (!button) {
		return;
	}

	return (
		<Modal title={button.title}>
			<Editor content={button.value} />
		</Modal>
	);
}
